(function () {
  "use strict";

  angular
    .module("admin.scheduled_configurations.service", [])
    .factory("ScheduledConfigurationsService", ScheduledConfigurationsService);

  /** @ngInject */
  function ScheduledConfigurationsService($http, $q, API) {
    function list(start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/scheduled_configurations?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve);

      return defered.promise;
    }

    function listActive() {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/scheduled_configurations/active")
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/scheduled_configurations/" + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/scheduled_configurations", model)
        .success(defered.resolve);

      return defered.promise;
    }

    function update(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/scheduled_configurations/" + id, model)
        .success(defered.resolve);

      return defered.promise;
    }

    function remove(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/scheduled_configurations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
      listActive: listActive,
      get: get,
      save: save,
      update: update,
      remove: remove,
    };
  }
})();
